import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { BeneficiaryAccountComponent } from './components/beneficiary-account/beneficiary-account';
import { BeneficiaryContactComponent } from './components/beneficiary-contact/beneficiary-contact';

import { BeneficiarySelectorUiComponent } from './beneficiary-selector-ui.component';
import { BeneficiaryTabsComponent } from './components/beneficiary-tabs/beneficiary-tabs';
import { ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BeneficiaryScrollDirective, BeneficiaryScrollItemDirective } from './directives/beneficiary-scroll.directive';

import { AmountModule, ButtonModule, DropdownMenuModule, EmptyStateModule,
  IconModule, FocusModule, KeyboardClickModule, LoadingIndicatorModule, HighlightModule, SearchBoxModule } from '@backbase/ui-ang';

import { PaymentsSrSearchResultInfoModule } from 'sr-search-result-info';
import { BbKeyboardNavigationModule } from 'beneficiary-selector-ui-directives';
import { BeneficiaryCatalogComponent } from './components/beneficiary-catalogue/beneficiary-catalog';
import { InputValidationMessageModule } from '@backbase/ui-ang';

const components = [
  BeneficiarySelectorUiComponent,
  BeneficiaryTabsComponent,
  BeneficiaryContactComponent,
  BeneficiaryCatalogComponent,
  BeneficiaryAccountComponent,
  BeneficiaryScrollDirective,
  BeneficiaryScrollItemDirective,
];

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    IconModule,
    SearchBoxModule,
    EmptyStateModule,
    HighlightModule,
    DropdownMenuModule,
    ButtonModule,
    LoadingIndicatorModule,
    KeyboardClickModule,
    AmountModule,
    PaymentsSrSearchResultInfoModule,
    ScrollingModule,
    InputValidationMessageModule,
    BbKeyboardNavigationModule,
    FocusModule
  ],
  exports: [BeneficiarySelectorUiComponent],
})
export class BeneficiarySelectorUIModule {}
